
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17.403","height":"16.003"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Icon feather-map","fill":"none","stroke":"#f36628","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"data-name":"패스 577","d":"M1 3.8V15l4.9-2.8 5.6 2.8 4.9-2.8V1l-4.9 2.8L5.9 1z"}}),_c('path',{attrs:{"data-name":"패스 578","d":"M5.901 1v11.2"}}),_c('path',{attrs:{"data-name":"패스 579","d":"M11.502 3.801v11.2"}})])])
          )
        }
      }
    